{
  "name": "linq-client",
  "version": "3.0.0",
  "scripts": {
    "ng": "ng",
    "start": "ng serve --proxy-config proxy-config.json",
    "build": "ng build",
    "prebuild-prod": "npm test",
    "build-prod": "ng build --configuration production",
    "prebuild-test": "npm test",
    "build-test": "ng build --configuration test",
    "watch": "ng build --watch --configuration development",
    "test": "ng test --watch=false",
    "check:cycles": "madge --circular --extensions ts --ts-config tsconfig.app.json src/main.ts",
    "bundle:report": "source-map-explorer 'dist/**/*.js' 'dist/**/*.css' --no-border-checks"
  },
  "private": true,
  "dependencies": {
    "@abacritt/angularx-social-login": "^2.5.1",
    "@angular/animations": "^21.2.25",
    "@angular/cdk": "^21.1.2",
    "@angular/common": "^21.2.25",
    "@angular/compiler": "^21.2.25",
    "@angular/core": "^21.2.25",
    "@angular/forms": "^21.2.25",
    "@angular/material": "^21.1.2",
    "@angular/platform-browser": "^21.2.25",
    "@angular/platform-browser-dynamic": "^21.2.25",
    "@angular/router": "^21.2.25",
    "@angular/service-worker": "^21.2.25",
    "@azure/msal-angular": "^5.1.1",
    "@azure/msal-browser": "^5.4.0",
    "@ngx-translate/core": "^17.0.0",
    "@ngx-translate/http-loader": "^17.0.0",
    "@types/d3": "^7.4.3",
    "@yfiles/yfiles": "31.0.1",
    "chart.js": "^4.5.1",
    "chartjs-chart-treemap": "^3.1.0",
    "chartjs-plugin-datalabels": "^2.2.0",
    "date-fns": "^4.1.0",
    "dompurify": "^3.4.17",
    "html2canvas": "^1.4.1",
    "jspdf": "^4.0.0",
    "jspdf-autotable": "^5.0.2",
    "ng2-charts": "^10.0.0",
    "ngx-cookie-service": "^21.1.0",
    "rxjs": "^7.8.2",
    "tslib": "^2.8.1",
    "uuid": "^13.0.0",
    "zone.js": "^0.16.0"
  },
  "devDependencies": {
    "@angular/build": "^21.2.26",
    "@angular/cli": "^21.1.2",
    "@angular/compiler-cli": "^21.2.25",
    "@playwright/test": "^1.57.0",
    "@testing-library/angular": "^19.0.0",
    "@testing-library/dom": "^10.0.0",
    "@types/node": "^25.1.0",
    "@types/uuid": "^11.0.0",
    "@typescript-eslint/eslint-plugin": "^8.58.0",
    "@typescript-eslint/parser": "^8.58.0",
    "eslint": "^10.2.0",
    "jsdom": "^30.1.1",
    "madge": "^8.0.0",
    "typescript": "~5.9.3",
    "vitest": "^4.1.11"
  },
  "allowScripts": {
    "@parcel/watcher@2.5.6": true,
    "core-js@3.48.0": true,
    "esbuild@0.27.3": true,
    "lmdb@3.5.1": true,
    "msgpackr-extract@3.0.3": true
  }
}
